import { RequirePermission } from "@backstage/plugin-permission-react";
import { Box, Text } from "@backstage/ui";
import { PermissionDenied } from "@internal/backstage-plugin-utility-react";
import { administerPermission } from "@internal/plugin-admin-common";

import styles from "./AdminContent.module.css";

/** Placeholder admin content, gated behind administerPermission. Shared between AdminPage and the DevTools sub-page. */
export const AdminContent = () => (
    <RequirePermission
        permission={administerPermission}
        errorPage={
            <PermissionDenied message="This view requires administration privileges." />
        }
    >
        <Box className={styles.container}>
            <Text variant="title-large">Admin</Text>
            <Text variant="body-medium">
                This is a placeholder page for administration - coming soon.
            </Text>
        </Box>
    </RequirePermission>
);
